import { map, head, last } from 'ramda';
import * as Functional from '../functional';
import { createSchemaBasedConstructor } from './create-typed-constructor';

const BoundingBox = createSchemaBasedConstructor('BoundingBox');

/*
 * Create a bounding box from a bounds polygon
 * @sig fromBoundsPolygon :: BoundsPolygon -> BoundingBox
 */
BoundingBox.fromBoundsPolygon = boundsPolygon => {
    const lats = map(head, boundsPolygon);
    const lngs = map(last, boundsPolygon);

    const w = Functional.min(lngs);
    const e = Functional.max(lngs);
    const n = Functional.max(lats);
    const s = Functional.min(lats);

    return BoundingBox(n, e, s, w);
};

export default BoundingBox;
